import React, { useState } from 'react';
import { createOrg } from '../../../Redux/actions/organization/create';
import { addNotification } from "../../../Utilities/notifications";
import { uploadProfilePic} from "../../../Redux/actions/user";
import empty_profile from "../../../Assets/emptyimage.png";
import { connect } from 'react-redux';
import axios from 'axios';
import "./index.css";

function CreateOrg(props) {    
    let {history} = props;
    let state = {
        display_name: "",
        contact_email: "",
        description:"",
        url:"",
        location:"",
        billing_email:"",
        profile_pic:""
    }

    let { user } = props;
    let [obj, setObj] = useState(state);
    let [err,setErr] = useState(false)
    const [loading, setLoading] = useState(false);
    
    const handleSubmit = async (e) => {      
        e.preventDefault();        
        if(!obj.contact_email){
            obj.contact_email = user.email;
        }  
                
        let {data}=await axios.get(`https://open.kickbox.com/v1/disposable/${obj.contact_email}`)
          
        if( !data.disposable && !obj.contact_email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)==false ){
          setLoading(true);
          let response = await createOrg(obj);
          setLoading(false);
        
           if(response === 201){
                addNotification({
                title: "Techforce.ai",
                message: "Organization has been Created Successfully",
                type: "success"
                });
            }
            window.location.reload()
            props.toggle()
        }
        else{
          addNotification({
            title: "Techforce.ai",
            message: "Please Enter EmailId or Enter Valid EmailId",
            type:"danger"
          }); 
        }        
    }

    const handleChange = (e) => {
        if(e.target.name === "display_name"){
          setErr(false)
        }
        obj = { ...obj, [e.target.name]: e.target.value }
        setObj(obj)
    }

    const uploadPic = async(e) =>{              
        let file = e.target.files[0] 
        if(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/jfif'){     
          let data = await uploadProfilePic(file)           
          setObj({ ...obj, profile_pic: data.URL });
        }
    }

    const focusOut = async(e) => {
      if(obj.display_name){
          let response = await createOrg(obj);
          if(response===202 ){
            setErr(true)
          } 
      }
    };
    const keyPress = async(e) => {
      if (e.key === 'Enter' ){
        e.preventDefault()      
      }
    }

    return (
        <div>
          {err ? <div className="alert alert-danger" role="alert">
             Organization Already Exist for Same User or Another User           
           </div> :""
          }
            <div className="rect-img " style={{marginTop:"-15px",}}>
            <img style={{marginLeft:"85%",height:"62px",width:"62px"}}
              src={obj.profile_pic ? obj.profile_pic : empty_profile}
              className="rounded  d-block"
              alt="..."
            />
            <span style={{marginRight:"28px",float:"right"}}>Upload</span>  
            <div className="orgprofile"><input type="file" name="profile_pic" accept="image/*" onChange={uploadPic}/></div>
            
          </div>

            <form className="form-container" onSubmit={handleSubmit} onKeyPress={keyPress}>
                <div className="form-group">
                    <label htmlFor="exampleInputEmail1"> Organization Name</label>
                    <input type="text" className="form-control-1" name="display_name" onKeyPress={keyPress} onBlur={focusOut}  onChange={handleChange} value={obj.display_name} placeholder="Enter" required></input>
                </div>
                <div className="form-group">
                    <label htmlFor="exampleInputEmail1"> Organization email</label>
                    <input type="email" className="form-control-1" name="contact_email" onChange={handleChange} value={obj.contact_email} placeholder="Enter" required></input>
                    <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small>
                </div>
                <div className="form-group">
              <label htmlFor="description">Description</label>
              <input
                type="text"
                name="description"
                onChange={handleChange}
                value={obj.description}
                className="form-control-1"
                id="description"
                placeholder="Enter"
              />
            </div>
            <div className="form-group">
              <label htmlFor="url">Website/Url</label>
              <input
                type="text"
                name="url"
                onChange={handleChange}
                value={obj.url}
                className="form-control-1"
                id="url"
                placeholder="Enter"
              />
            </div>
            <div className="form-group">
              <label htmlFor="billing_email">Billing Email (private)</label>
              <input
                type="text"
                name="billing_email"
                onChange={handleChange}
                value={obj.billing_email}
                className="form-control-1"
                id="billing_email"
              />
            </div>

            <div className="form-group">
              <label htmlFor="location">Location</label>
              <input
                type="text"
                name="location"
                onChange={handleChange}
                value={obj.location}
                className="form-control-1"
                id="location"
                placeholder="Enter"
              />
            </div>
            
                <div className="text">
                    <button className="button" onClick={()=>props.toggle()} style={{marginLeft:"10px !important" }}>
                                Cancel
                    </button>
                    <button className="btn" type="submit" onClick={handleSubmit} disabled={obj.display_name? false:true || err}>{loading ? <i
                        style={{ fontSize: "15px", color: "#ffffff"}}
                        className="fas fa-circle-notch fa-spin"
                    ></i> : "Submit" }</button>
                </div>
            </form>
        </div>
    )
}
const mapStateToProps = (state) => ({
    user: state.user
})

export default connect(mapStateToProps, null)(CreateOrg)

